/* assets/alb-haendlermap.js · ALB Horizon Rebuild
   Web Component fuer sections/alb-haendlermap.liquid.
   Progressive Enhancement: Karte + Liste stehen bereits serverseitig im DOM
   (Quelle: Shop-Metafeld alb.haendler bzw. Section-Blocks); hier kommen
   Filter, Suche, Marker-Interaktion, Info-Karte und Zoom/Pan dazu.
   LIVE-SHEET: Traegt die Section ein data-sheet-Attribut (CSV-URL eines im
   Web veroeffentlichten Google Sheets), wird die Partnerliste beim Laden
   direkt von dort uebernommen und Karte/Liste neu gerendert — Pflege ohne
   Sync-Schritt. Der Server-Stand bleibt Fallback (SEO, kein JS, Ausfall).
   Kein externes JS (§ Konventionen), prefers-reduced-motion respektiert.
   Projektion identisch zu snippets/alb-haendlermap-pin.liquid:
   x = (lng - 2.1384703) * 57.34279 ; y = (55.2135225 - lat) * 91.40018 */
(function () {
  'use strict';

  if (customElements.get('alb-haendlermap')) return;

  var KAT_LABEL = { camping: 'Camping', home: 'Home', boot: 'Boot' };
  var KATS = ['camping', 'home', 'boot'];
  var MAX_ZOOM = 8;
  var LON0 = 2.1384703, XK = 57.34279, LAT1 = 55.2135225, YK = 91.40018;
  var VIEW_W = 760, VIEW_H = 744.1;

  var reducedMotion = false;
  try {
    reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) { /* alte Browser: Animationen einfach an */ }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function AlbHaendlermap() {
    return Reflect.construct(HTMLElement, [], AlbHaendlermap);
  }
  AlbHaendlermap.prototype = Object.create(HTMLElement.prototype);
  AlbHaendlermap.prototype.constructor = AlbHaendlermap;

  AlbHaendlermap.prototype.connectedCallback = function () {
    if (this._init) return;
    this._init = true;

    var root = this;
    this.svg = root.querySelector('.alb-hm-svg');
    this.mapEl = root.querySelector('[data-map]');
    this.pinsGroup = root.querySelector('[data-pins]');
    this.chips = Array.prototype.slice.call(root.querySelectorAll('.alb-hm-chip'));
    this.searchInput = root.querySelector('.alb-hm-search-input');
    this.listEl = root.querySelector('[data-list]');
    this.noResult = root.querySelector('[data-noresult]');
    this.tip = root.querySelector('[data-tip]');
    this.hint = root.querySelector('[data-hint]');
    this.card = root.querySelector('[data-card]');

    if (!this.svg || !this.mapEl) return;

    // Basis-viewBox merken (Zoom manipuliert sie)
    var vb = this.svg.viewBox.baseVal;
    this.base = { x: vb.x, y: vb.y, w: vb.width, h: vb.height };
    this.view = { x: vb.x, y: vb.y, w: vb.width, h: vb.height };

    // Partnerdaten (fuer Info-Karte)
    this.daten = {};
    var dataEl = root.querySelector('[data-partner-daten]');
    if (dataEl) {
      try {
        JSON.parse(dataEl.textContent).forEach(function (p) { root.daten[p.id] = p; });
      } catch (e) { /* ohne Daten bleibt die Karte trotzdem nutzbar */ }
    }

    this.filterCat = 'alle';
    this.filterText = '';
    this.sortKey = 'standard';
    this.activeId = null;
    this._hintTimer = null;

    this._bindChips();
    this._bindSearch();
    this._bindSort();
    this._bindCard();
    this._bindZoom();
    this._refreshRefs();
    this._bindDynamic();
    this._ladeSheet();
  };

  /* ---------- Sortierung ---------- */

  AlbHaendlermap.prototype._bindSort = function () {
    var self = this;
    var select = this.querySelector('[data-sort]');
    if (!select) return;
    select.addEventListener('change', function () {
      self.sortKey = select.value;
      self._applySort();
    });
  };

  // Sortiert die Eintraege innerhalb jeder Kategorie-Gruppe im DOM um.
  // 'standard' = gelieferte Reihenfolge (data-idx wird beim ersten Lauf gemerkt).
  AlbHaendlermap.prototype._applySort = function () {
    var key = this.sortKey;
    this.groups.forEach(function (group) {
      var items = Array.prototype.slice.call(group.querySelectorAll('.alb-hm-li'));
      items.forEach(function (it, i) {
        if (!it.hasAttribute('data-idx')) it.setAttribute('data-idx', String(i));
      });
      items.sort(function (a, b) {
        if (key === 'plz') {
          var pa = parseInt(a.getAttribute('data-plz'), 10);
          var pb = parseInt(b.getAttribute('data-plz'), 10);
          if (isNaN(pa)) pa = Infinity;
          if (isNaN(pb)) pb = Infinity;
          if (pa !== pb) return pa - pb;
          return (a.getAttribute('data-ort') || '').localeCompare(b.getAttribute('data-ort') || '', 'de');
        }
        if (key === 'ort' || key === 'name') {
          var attr = 'data-' + key;
          var va = a.getAttribute(attr) || '';
          var vb = b.getAttribute(attr) || '';
          // leere Werte ans Ende
          if (!va && vb) return 1;
          if (va && !vb) return -1;
          var c = va.localeCompare(vb, 'de');
          if (c !== 0) return c;
          return (a.getAttribute('data-name') || '').localeCompare(b.getAttribute('data-name') || '', 'de');
        }
        return parseInt(a.getAttribute('data-idx'), 10) - parseInt(b.getAttribute('data-idx'), 10);
      });
      items.forEach(function (it) { group.appendChild(it); });
    });
  };

  /* ---------- dynamische Referenzen (Pins/Liste koennen neu gerendert werden) */

  AlbHaendlermap.prototype._refreshRefs = function () {
    this.pins = Array.prototype.slice.call(this.querySelectorAll('.alb-hm-pin'));
    // Marker UND Staedte-Labels werden beim Zoom gegen-skaliert (konstante Groesse)
    this.pinScales = Array.prototype.slice.call(this.querySelectorAll('.alb-hm-pin-s, .alb-hm-city-s'));
    this.items = Array.prototype.slice.call(this.querySelectorAll('.alb-hm-li'));
    this.groups = Array.prototype.slice.call(this.querySelectorAll('.alb-hm-group'));
  };

  AlbHaendlermap.prototype._bindDynamic = function () {
    this._bindPins();
    this._bindList();
  };

  /* ---------- Live-Daten aus dem veroeffentlichten Google Sheet ---------- */

  AlbHaendlermap.prototype._ladeSheet = function () {
    var url = this.getAttribute('data-sheet');
    if (!url || !window.fetch) return;
    var self = this;
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    if (ctrl) setTimeout(function () { ctrl.abort(); }, 8000);
    fetch(url, { credentials: 'omit', signal: ctrl && ctrl.signal })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('HTTP ' + r.status)); })
      .then(function (text) { self._uebernehmeSheetCsv(text); })
      .catch(function () { /* Sheet nicht erreichbar → Server-Stand bleibt */ });
  };

  // Auch fuer manuelle Tests aufrufbar: uebernimmt einen CSV-Text
  AlbHaendlermap.prototype._uebernehmeSheetCsv = function (text) {
    var zeilen = this._parseCsv(String(text).replace(/^\uFEFF/, ''));
    if (zeilen.length < 2) return;
    var daten = this._normalisiere(zeilen);
    if (daten.length < 5) return; // Schutz vor versehentlich geleertem Sheet

    // Nur neu rendern, wenn sich gegenueber dem Server-Stand etwas aendert
    var self = this;
    function sig(p) {
      return [p.name, (p.cats || []).join('|'), p.strasse, p.ort, p.land,
        p.website, p.email, p.hinweis,
        p.lat == null ? '' : Number(p.lat).toFixed(4),
        p.lng == null ? '' : Number(p.lng).toFixed(4)].join(';');
    }
    var alt = Object.keys(this.daten).map(function (k) { return sig(self.daten[k]); }).join('\n');
    var neu = daten.map(sig).join('\n');
    if (alt === neu) return;

    this._renderDaten(daten);
  };

  AlbHaendlermap.prototype._parseCsv = function (text) {
    var zeilen = [], feld = '', zeile = [], inQ = false;
    for (var i = 0; i < text.length; i++) {
      var c = text[i];
      if (inQ) {
        if (c === '"') {
          if (text[i + 1] === '"') { feld += '"'; i++; } else inQ = false;
        } else feld += c;
      } else if (c === '"') {
        inQ = true;
      } else if (c === ',') {
        zeile.push(feld); feld = '';
      } else if (c === '\n' || c === '\r') {
        if (c === '\r' && text[i + 1] === '\n') i++;
        zeile.push(feld); feld = '';
        if (zeile.length > 1 || zeile[0] !== '') zeilen.push(zeile);
        zeile = [];
      } else feld += c;
    }
    if (feld !== '' || zeile.length) { zeile.push(feld); zeilen.push(zeile); }
    return zeilen;
  };

  AlbHaendlermap.prototype._normalisiere = function (zeilen) {
    // Spalten anhand der Kopfzeile finden (Reihenfolge im Sheet egal)
    var kopf = zeilen[0].map(function (h) { return String(h).trim().toLowerCase(); });
    function spalte(tests) {
      for (var i = 0; i < kopf.length; i++) {
        for (var t = 0; t < tests.length; t++) {
          if (kopf[i].indexOf(tests[t]) === 0) return i;
        }
      }
      return -1;
    }
    var idx = {
      name: spalte(['name']),
      camping: spalte(['camping']),
      home: spalte(['home']),
      boot: spalte(['boot']),
      strasse: spalte(['straße', 'strasse']),
      ort: spalte(['plz']),
      land: spalte(['land']),
      website: spalte(['website', 'webseite']),
      email: spalte(['e-mail', 'email']),
      hinweis: spalte(['hinweis']),
      lat: spalte(['lat', 'breitengrad']),
      lng: spalte(['lng', 'lon', 'längengrad', 'laengengrad'])
    };
    if (idx.name < 0) return [];

    function wert(z, i) { return i >= 0 && z[i] != null ? String(z[i]).trim() : ''; }
    function zahl(s) {
      var v = parseFloat(String(s).replace(',', '.'));
      return isFinite(v) ? v : null;
    }

    var out = [];
    for (var r = 1; r < zeilen.length; r++) {
      var z = zeilen[r];
      var name = wert(z, idx.name);
      if (!name) continue;
      var cats = [];
      KATS.forEach(function (k) { if (wert(z, idx[k])) cats.push(k); });
      if (!cats.length) cats = ['camping'];
      var lat = zahl(wert(z, idx.lat));
      var lng = zahl(wert(z, idx.lng));
      // Plausibilitaet (Kartenausschnitt); ausserhalb → nur Liste, kein Marker
      if (lat === null || lng === null || lat < 40 || lat > 60 || lng < 0 || lng > 20) { lat = null; lng = null; }
      out.push({
        id: 'sheet_' + out.length,
        name: name, cats: cats,
        strasse: wert(z, idx.strasse), ort: wert(z, idx.ort), land: wert(z, idx.land) || 'Deutschland',
        website: wert(z, idx.website), email: wert(z, idx.email), hinweis: wert(z, idx.hinweis),
        lat: lat, lng: lng
      });
    }
    return out;
  };

  /* ---------- Neu-Rendern von Markern, Liste und Chip-Zaehlern ---------- */

  AlbHaendlermap.prototype._pinMarkup = function (p) {
    var x = (p.lng - LON0) * XK;
    var y = (LAT1 - p.lat) * YK;
    if (!(x >= 0 && x <= VIEW_W && y >= 0 && y <= VIEW_H)) return '';
    var haupt = p.cats[0] || 'camping';
    var label = p.name + (p.ort ? ', ' + p.ort : '');
    return '<g class="alb-hm-pin" data-id="' + esc(p.id) + '" data-cats="' + esc(p.cats.join(' ')) + '"' +
      ' data-cat="' + esc(haupt) + '" transform="translate(' + x.toFixed(1) + ' ' + y.toFixed(1) + ')"' +
      ' tabindex="0" role="button" aria-label="' + esc(label) + '">' +
      '<g class="alb-hm-pin-s"><circle class="alb-hm-pin-puls" cy="-18" r="10"/><g class="alb-hm-pin-v">' +
      '<circle class="alb-hm-pin-hit" cy="-12" r="16"/>' +
      '<path class="alb-hm-pin-m" d="M0 0C-1.8 -4.6 -10 -10.5 -10 -18A10 10 0 1 1 10 -18C10 -10.5 1.8 -4.6 0 0Z"/>' +
      '<circle class="alb-hm-pin-i" cy="-18" r="3.8"/>' +
      '</g></g></g>';
  };

  AlbHaendlermap.prototype._itemMarkup = function (p) {
    var such = (p.name + ' ' + p.ort).toLowerCase();
    var dom = String(p.website || '').replace(/^https?:\/\//, '');
    var plz = String(p.ort || '').split(' ')[0] || '';
    var ortName = String(p.ort || '').slice(plz.length).trim().toLowerCase();
    var html = '<details class="alb-hm-li" data-id="' + esc(p.id) + '" data-search="' + esc(such) + '"' +
      ' data-name="' + esc(String(p.name).toLowerCase()) + '" data-plz="' + esc(plz) + '" data-ort="' + esc(ortName) + '">' +
      '<summary class="alb-hm-li-sum"><span class="alb-hm-li-name">' + esc(p.name) + '</span>' +
      (p.ort ? '<span class="alb-hm-li-ort">' + esc(p.ort) + '</span>' : '') + '</summary>' +
      '<div class="alb-hm-li-body">';
    if (p.strasse || p.ort) {
      html += '<p class="alb-hm-li-addr">' + (p.strasse ? esc(p.strasse) + '<br>' : '') + esc(p.ort) +
        (p.land && p.land !== 'Deutschland' ? ' · ' + esc(p.land) : '') + '</p>';
    }
    if (p.hinweis) html += '<p class="alb-hm-li-note">' + esc(p.hinweis) + '</p>';
    html += '<p class="alb-hm-li-links">';
    if (dom) html += '<a href="https://' + esc(dom) + '" target="_blank" rel="noopener nofollow">' + esc(dom.replace(/^www\./, '')) + '</a>';
    if (p.email) html += '<a href="mailto:' + esc(p.email) + '">' + esc(p.email) + '</a>';
    html += '</p></div></details>';
    return html;
  };

  AlbHaendlermap.prototype._renderDaten = function (arr) {
    var self = this;
    this._deselect();

    // Marker
    this.pinsGroup.innerHTML = arr.map(function (p) {
      return p.lat === null ? '' : self._pinMarkup(p);
    }).join('');

    // Liste (Gruppen in fester Kategorie-Reihenfolge)
    var listeHtml = '';
    KATS.forEach(function (kat) {
      var drin = arr.filter(function (p) { return p.cats.indexOf(kat) !== -1; });
      if (!drin.length) return;
      listeHtml += '<div class="alb-hm-group" data-group="' + kat + '">' +
        '<p class="alb-hm-group-h"><span class="alb-hm-dot alb-hm-dot--' + kat + '" aria-hidden="true"></span>' +
        KAT_LABEL[kat] + ' <span class="alb-hm-group-n" data-group-n>(' + drin.length + ')</span></p>' +
        drin.map(function (p) { return self._itemMarkup(p); }).join('') + '</div>';
    });
    this.listEl.innerHTML = listeHtml;

    // Chip-Zaehler
    this.chips.forEach(function (chip) {
      var cat = chip.getAttribute('data-cat');
      var n = cat === 'alle' ? arr.length : arr.filter(function (p) { return p.cats.indexOf(cat) !== -1; }).length;
      var span = chip.querySelector('.alb-hm-chip-n');
      if (span) span.textContent = String(n);
      if (cat !== 'alle') chip.hidden = n === 0;
    });

    // Datenindex fuer die Info-Karte
    this.daten = {};
    arr.forEach(function (p) { self.daten[p.id] = p; });

    this._refreshRefs();
    this._bindDynamic();
    this._applyView();
    this._applyFilter();
    this._applySort();
  };

  /* ---------- Filter ---------- */

  AlbHaendlermap.prototype._bindChips = function () {
    var self = this;
    this.chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        self.filterCat = chip.getAttribute('data-cat') || 'alle';
        self.chips.forEach(function (c) {
          var on = c === chip;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        self._applyFilter();
      });
    });
  };

  AlbHaendlermap.prototype._bindSearch = function () {
    var self = this;
    if (!this.searchInput) return;
    this.searchInput.addEventListener('input', function () {
      self.filterText = self.searchInput.value.trim().toLowerCase();
      self._applyFilter();
    });
  };

  AlbHaendlermap.prototype._matches = function (cats, search) {
    if (this.filterCat !== 'alle' && cats.indexOf(this.filterCat) === -1) return false;
    if (this.filterText && search.indexOf(this.filterText) === -1) return false;
    return true;
  };

  AlbHaendlermap.prototype._applyFilter = function () {
    var self = this;
    var sichtbar = 0;

    this.pins.forEach(function (pin) {
      var cats = (pin.getAttribute('data-cats') || '').split(' ');
      var id = pin.getAttribute('data-id');
      var item = self._itemById(id);
      var search = item ? (item.getAttribute('data-search') || '') : '';
      var ok = self._matches(cats, search);
      pin.classList.toggle('is-dim', !ok);
      pin.setAttribute('tabindex', ok ? '0' : '-1');
    });

    this.groups.forEach(function (group) {
      var gcat = group.getAttribute('data-group');
      var gOk = self.filterCat === 'alle' || self.filterCat === gcat;
      var offen = 0;
      Array.prototype.forEach.call(group.querySelectorAll('.alb-hm-li'), function (item) {
        var hit = gOk && (!self.filterText || (item.getAttribute('data-search') || '').indexOf(self.filterText) !== -1);
        item.hidden = !hit;
        if (hit) offen++;
      });
      group.hidden = offen === 0;
      var n = group.querySelector('[data-group-n]');
      if (n) n.textContent = '(' + offen + ')';
      sichtbar += offen;
    });

    if (this.noResult) this.noResult.hidden = sichtbar > 0;

    if (this.activeId) {
      var aktPin = this._pinById(this.activeId);
      if (aktPin && aktPin.classList.contains('is-dim')) this._deselect();
    }
  };

  /* ---------- Auswahl / Info-Karte ---------- */

  AlbHaendlermap.prototype._pinById = function (id) {
    for (var i = 0; i < this.pins.length; i++) {
      if (this.pins[i].getAttribute('data-id') === id) return this.pins[i];
    }
    return null;
  };

  AlbHaendlermap.prototype._itemById = function (id) {
    for (var i = 0; i < this.items.length; i++) {
      if (this.items[i].getAttribute('data-id') === id) return this.items[i];
    }
    return null;
  };

  AlbHaendlermap.prototype._bindPins = function () {
    var self = this;
    this.pins.forEach(function (pin) {
      pin.addEventListener('click', function (ev) {
        ev.stopPropagation();
        self._select(pin.getAttribute('data-id'), true);
      });
      pin.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') {
          ev.preventDefault();
          self._select(pin.getAttribute('data-id'), true);
        }
      });
      pin.addEventListener('pointerenter', function () { self._showTip(pin); });
      pin.addEventListener('pointerleave', function () { self._hideTip(); });
      pin.addEventListener('focus', function () { self._showTip(pin); });
      pin.addEventListener('blur', function () { self._hideTip(); });
    });

    if (!this._svgClickGebunden) {
      this._svgClickGebunden = true;
      // Klick auf die Kartenflaeche (nicht auf einen Marker) schliesst die Karte;
      // nach einem Drag/Pinch ist der Klick nur das Gestenende
      this.svg.addEventListener('click', function () {
        if (self._wasDrag) { self._wasDrag = false; return; }
        self._deselect();
      });
      this.mapEl.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape') self._deselect();
      });
    }
  };

  AlbHaendlermap.prototype._showTip = function (pin) {
    if (!this.tip || this.card && !this.card.hidden && this.activeId === pin.getAttribute('data-id')) return;
    var name = pin.getAttribute('aria-label') || '';
    var pos = this._pinScreenPos(pin);
    if (!pos) return;
    this.tip.textContent = name;
    this.tip.style.left = pos.x + 'px';
    this.tip.style.top = pos.y + 'px';
    this.tip.hidden = false;
  };

  AlbHaendlermap.prototype._hideTip = function () {
    if (this.tip) this.tip.hidden = true;
  };

  AlbHaendlermap.prototype._pinScreenPos = function (pin) {
    // Marker-Position (SVG-Koordinaten) in Pixel relativ zum Karten-Container
    var t = pin.transform.baseVal;
    if (!t.numberOfItems) return null;
    var m = t.getItem(0).matrix;
    var rect = this.svg.getBoundingClientRect();
    var mapRect = this.mapEl.getBoundingClientRect();
    var sx = rect.width / this.view.w;
    var sy = rect.height / this.view.h;
    return {
      x: (m.e - this.view.x) * sx + (rect.left - mapRect.left),
      y: (m.f - this.view.y) * sy + (rect.top - mapRect.top)
    };
  };

  AlbHaendlermap.prototype._select = function (id, oeffneListe, quellItem) {
    var pin = this._pinById(id);
    var daten = this.daten[id];
    this._hideTip();

    if (this.activeId) {
      var alt = this._pinById(this.activeId);
      if (alt) alt.classList.remove('is-active');
    }

    // Accordion: immer nur ein Listeneintrag offen. Das geklickte/gewaehlte
    // Element selbst bleibt unberuehrt (beim erneuten Klick regelt das native
    // details-Toggle das Schliessen).
    var ziel = quellItem || this._itemById(id);
    this.items.forEach(function (it) {
      if (it === ziel) return;
      it.classList.remove('is-active');
      if (it.open) it.open = false;
    });

    this.activeId = id;
    if (pin) pin.classList.add('is-active');

    if (ziel) {
      ziel.classList.add('is-active');
      if (oeffneListe) {
        ziel.open = true;
        if (this.listEl) {
          ziel.scrollIntoView({ block: 'nearest', behavior: reducedMotion ? 'auto' : 'smooth' });
        }
      }
    }

    if (daten) {
      this._fillCard(daten);
      this._placeCard(pin);
    }
  };

  // Waehlt fuer die Info-Karte die Ecke, die den aktiven Marker nicht
  // verdeckt (Reihenfolge: unten links, unten rechts, oben links, oben rechts).
  AlbHaendlermap.prototype._placeCard = function (pin) {
    if (!this.card || this.card.hidden) return;
    var card = this.card;
    card.classList.remove('alb-hm-card--br', 'alb-hm-card--tl', 'alb-hm-card--tr');
    if (!pin) return;
    var pos = this._pinScreenPos(pin);
    if (!pos) return;
    var mapR = this.mapEl.getBoundingClientRect();
    var cw = card.offsetWidth;
    var ch = card.offsetHeight;
    // Marker-Bereich um den Fusspunkt (Tropfen ragt ~34px nach oben) + Puffer
    var m = { x1: pos.x - 24, x2: pos.x + 24, y1: pos.y - 46, y2: pos.y + 12 };
    var ecken = [
      { cls: '', x1: 12, y1: mapR.height - 12 - ch },
      { cls: 'alb-hm-card--br', x1: mapR.width - 12 - cw, y1: mapR.height - 12 - ch },
      { cls: 'alb-hm-card--tl', x1: 12, y1: 12 },
      { cls: 'alb-hm-card--tr', x1: mapR.width - 12 - cw, y1: 12 }
    ];
    for (var i = 0; i < ecken.length; i++) {
      var e = ecken[i];
      var frei = e.x1 > m.x2 || e.x1 + cw < m.x1 || e.y1 > m.y2 || e.y1 + ch < m.y1;
      if (frei) {
        if (e.cls) card.classList.add(e.cls);
        return;
      }
    }
    // keine freie Ecke (sehr kleine Karte): Standard unten links
  };

  AlbHaendlermap.prototype._deselect = function () {
    if (this.card) this.card.hidden = true;
    if (this.activeId) {
      var pin = this._pinById(this.activeId);
      if (pin) pin.classList.remove('is-active');
      var item = this._itemById(this.activeId);
      if (item) item.classList.remove('is-active');
    }
    this.activeId = null;
  };

  AlbHaendlermap.prototype._fillCard = function (p) {
    if (!this.card) return;
    var q = function (sel) { return this.card.querySelector(sel); }.bind(this);

    var kats = q('[data-card-kats]');
    kats.innerHTML = '';
    (p.cats || []).forEach(function (cat) {
      if (!KAT_LABEL[cat]) return;
      var el = document.createElement('span');
      el.className = 'alb-hm-card-kat';
      var dot = document.createElement('span');
      dot.className = 'alb-hm-dot alb-hm-dot--' + cat;
      dot.setAttribute('aria-hidden', 'true');
      el.appendChild(dot);
      el.appendChild(document.createTextNode(KAT_LABEL[cat]));
      kats.appendChild(el);
    });

    q('[data-card-name]').textContent = p.name || '';

    var addrTeile = [];
    if (p.strasse) addrTeile.push(p.strasse);
    if (p.ort) addrTeile.push(p.ort);
    if (p.land && p.land !== 'Deutschland') addrTeile.push(p.land);
    var addrEl = q('[data-card-addr]');
    addrEl.textContent = addrTeile.join(', ');
    addrEl.hidden = addrTeile.length === 0;

    var noteEl = q('[data-card-note]');
    noteEl.textContent = p.hinweis || '';
    noteEl.hidden = !p.hinweis;

    var links = q('[data-card-links]');
    links.innerHTML = '';
    if (p.website) {
      var dom = String(p.website).replace(/^https?:\/\//, '');
      var a = document.createElement('a');
      a.href = 'https://' + dom;
      a.target = '_blank';
      a.rel = 'noopener nofollow';
      a.textContent = dom.replace(/^www\./, '');
      links.appendChild(a);
    }
    if (p.email) {
      var m = document.createElement('a');
      m.href = 'mailto:' + p.email;
      m.textContent = p.email;
      links.appendChild(m);
    }

    var route = q('[data-card-route]');
    if (addrTeile.length) {
      var ziel = addrTeile.slice();
      if (!p.land || p.land === 'Deutschland') ziel.push('Deutschland');
      route.href = 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(ziel.join(', '));
      route.hidden = false;
    } else {
      route.hidden = true;
    }

    this.card.hidden = false;
  };

  AlbHaendlermap.prototype._bindCard = function () {
    var self = this;
    if (!this.card) return;
    this.card.addEventListener('click', function (ev) { ev.stopPropagation(); });
    var close = this.card.querySelector('[data-card-close]');
    if (close) close.addEventListener('click', function () { self._deselect(); });
  };

  AlbHaendlermap.prototype._bindList = function () {
    var self = this;
    this.items.forEach(function (item) {
      var sum = item.querySelector('.alb-hm-li-sum');
      if (!sum) return;
      sum.addEventListener('click', function () {
        // natives details-Toggle laeuft weiter; zusaetzlich Marker markieren,
        // Karte auf den Marker zentrieren (falls gezoomt) und Puls anzeigen
        var id = item.getAttribute('data-id');
        self._select(id, false, item);
        self._centerOnPin(id);
        self._pulse(id);
      });
    });
  };

  // Karte (nur im gezoomten Zustand) weich auf den Marker zentrieren
  AlbHaendlermap.prototype._centerOnPin = function (id) {
    var pin = this._pinById(id);
    if (!pin || this._zoomFaktor() <= 1.01) return;
    var t = pin.transform.baseVal;
    if (!t.numberOfItems) return;
    var m = t.getItem(0).matrix;
    var self = this;
    var ziel = { x: m.e - this.view.w / 2, y: m.f - this.view.h / 2 };
    if (this._panAnim) cancelAnimationFrame(this._panAnim);
    if (reducedMotion) {
      this.view.x = ziel.x;
      this.view.y = ziel.y;
      this._applyView();
      this._placeCard(pin);
      return;
    }
    var start = { x: this.view.x, y: this.view.y };
    var t0 = null;
    var DAUER = 380;
    function schritt(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / DAUER);
      var e = 1 - Math.pow(1 - p, 3);
      self.view.x = start.x + (ziel.x - start.x) * e;
      self.view.y = start.y + (ziel.y - start.y) * e;
      self._applyView();
      if (p < 1) self._panAnim = requestAnimationFrame(schritt);
      else self._placeCard(pin);
    }
    this._panAnim = requestAnimationFrame(schritt);
  };

  AlbHaendlermap.prototype._pulse = function (id) {
    var pin = this._pinById(id);
    if (!pin) return;
    pin.classList.remove('is-pulse');
    pin.getBoundingClientRect();
    pin.classList.add('is-pulse');
  };

  /* ---------- Zoom & Pan ---------- */

  AlbHaendlermap.prototype._zoomFaktor = function () {
    return this.base.w / this.view.w;
  };

  AlbHaendlermap.prototype._applyView = function () {
    var v = this.view;
    var b = this.base;
    v.w = Math.min(b.w, Math.max(b.w / MAX_ZOOM, v.w));
    v.h = v.w * (b.h / b.w);
    v.x = Math.min(b.x + b.w - v.w, Math.max(b.x, v.x));
    v.y = Math.min(b.y + b.h - v.h, Math.max(b.y, v.y));
    this.svg.setAttribute('viewBox', v.x + ' ' + v.y + ' ' + v.w + ' ' + v.h);

    var z = this._zoomFaktor();
    var s = 1 / z;
    this.pinScales.forEach(function (g) {
      g.setAttribute('transform', 'scale(' + s + ')');
    });
    this.svg.classList.toggle('is-zoomed', z > 1.01);
    this._hideTip();
  };

  AlbHaendlermap.prototype._zoomAt = function (faktor, clientX, clientY) {
    var rect = this.svg.getBoundingClientRect();
    var v = this.view;
    var cx = v.x + ((clientX - rect.left) / rect.width) * v.w;
    var cy = v.y + ((clientY - rect.top) / rect.height) * v.h;
    var neuW = v.w / faktor;
    neuW = Math.min(this.base.w, Math.max(this.base.w / MAX_ZOOM, neuW));
    var f = neuW / v.w;
    v.x = cx - (cx - v.x) * f;
    v.y = cy - (cy - v.y) * f;
    v.w = neuW;
    this._applyView();
  };

  AlbHaendlermap.prototype._zoomMitte = function (faktor) {
    var rect = this.svg.getBoundingClientRect();
    this._zoomAt(faktor, rect.left + rect.width / 2, rect.top + rect.height / 2);
  };

  AlbHaendlermap.prototype._zeigeHint = function (text) {
    if (!this.hint) return;
    var self = this;
    this.hint.textContent = text;
    this.hint.hidden = false;
    requestAnimationFrame(function () { self.hint.classList.add('is-on'); });
    clearTimeout(this._hintTimer);
    this._hintTimer = setTimeout(function () {
      self.hint.classList.remove('is-on');
      setTimeout(function () { self.hint.hidden = true; }, 250);
    }, 1300);
  };

  AlbHaendlermap.prototype._bindZoom = function () {
    var self = this;

    Array.prototype.forEach.call(this.mapEl.querySelectorAll('[data-zoom]'), function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.stopPropagation();
        var art = btn.getAttribute('data-zoom');
        if (art === 'in') self._zoomMitte(1.6);
        else if (art === 'out') self._zoomMitte(1 / 1.6);
        else {
          self.view = { x: self.base.x, y: self.base.y, w: self.base.w, h: self.base.h };
          self._applyView();
        }
      });
    });

    this.svg.addEventListener('wheel', function (ev) {
      if (ev.ctrlKey || ev.metaKey) {
        ev.preventDefault();
        self._zoomAt(ev.deltaY < 0 ? 1.25 : 0.8, ev.clientX, ev.clientY);
      } else if (self._zoomFaktor() <= 1.01) {
        self._zeigeHint('Zum Zoomen Strg + Scrollen oder die +/− Buttons nutzen');
      }
    }, { passive: false });

    this.svg.addEventListener('dblclick', function (ev) {
      ev.preventDefault();
      self._zoomAt(1.6, ev.clientX, ev.clientY);
    });

    // Pan (Maus/ein Finger, nur gezoomt) + Pinch (zwei Finger).
    // Capture erst ab echter Bewegung, sonst kapert das SVG die Marker-Klicks;
    // nach einem Drag unterdrueckt _wasDrag den Folge-Klick (wuerde die
    // Info-Karte sofort wieder schliessen).
    var aktivePointer = new Map();
    var panStart = null;
    var pinchStart = null;
    self._wasDrag = false;

    this.svg.addEventListener('pointerdown', function (ev) {
      aktivePointer.set(ev.pointerId, { x: ev.clientX, y: ev.clientY });
      self._wasDrag = false;
      if (aktivePointer.size === 1 && self._zoomFaktor() > 1.01) {
        panStart = {
          px: ev.clientX, py: ev.clientY,
          vx: self.view.x, vy: self.view.y,
          id: ev.pointerId, captured: false
        };
      } else if (aktivePointer.size === 2) {
        panStart = null;
        var pts = Array.from(aktivePointer.values());
        pinchStart = {
          dist: Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y),
          w: self.view.w
        };
      }
    });

    this.svg.addEventListener('pointermove', function (ev) {
      if (!aktivePointer.has(ev.pointerId)) return;
      aktivePointer.set(ev.pointerId, { x: ev.clientX, y: ev.clientY });

      if (aktivePointer.size === 2 && pinchStart) {
        var pts = Array.from(aktivePointer.values());
        var dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        if (dist > 0 && pinchStart.dist > 0) {
          self._wasDrag = true;
          var mx = (pts[0].x + pts[1].x) / 2;
          var my = (pts[0].y + pts[1].y) / 2;
          var zielW = pinchStart.w * (pinchStart.dist / dist);
          self._zoomAt(self.view.w / zielW, mx, my);
        }
      } else if (panStart && aktivePointer.size === 1) {
        var dx = ev.clientX - panStart.px;
        var dy = ev.clientY - panStart.py;
        if (!panStart.captured) {
          if (Math.hypot(dx, dy) < 5) return;
          panStart.captured = true;
          self._wasDrag = true;
          self.svg.classList.add('is-panning');
          try { self.svg.setPointerCapture(panStart.id); } catch (e) { /* egal */ }
        }
        var rect = self.svg.getBoundingClientRect();
        self.view.x = panStart.vx - dx * (self.view.w / rect.width);
        self.view.y = panStart.vy - dy * (self.view.h / rect.height);
        self._applyView();
      }
    });

    function pointerEnde(ev) {
      aktivePointer.delete(ev.pointerId);
      if (aktivePointer.size < 2) pinchStart = null;
      if (aktivePointer.size === 0) {
        panStart = null;
        self.svg.classList.remove('is-panning');
      }
    }
    this.svg.addEventListener('pointerup', pointerEnde);
    this.svg.addEventListener('pointercancel', pointerEnde);
  };

  customElements.define('alb-haendlermap', AlbHaendlermap);
})();
